/**
 * @generated SignedSource<<4ec2886c9952f0f9f47a96617976e224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedTabTable_refetchableBrand$data = {
  readonly feedPosts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"FeedTabTableRow_feedPost">;
      };
    }>;
    readonly totalCount: number | null;
  };
  readonly id: string;
  readonly " $fragmentType": "FeedTabTable_refetchableBrand";
};
export type FeedTabTable_refetchableBrand$key = {
  readonly " $data"?: FeedTabTable_refetchableBrand$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedTabTable_refetchableBrand">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "feedPosts"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "audienceFilter"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "languageFilter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./FeedTabTablePaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "FeedTabTable_refetchableBrand",
  "selections": [
    {
      "alias": "feedPosts",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "audienceIds",
              "variableName": "audienceFilter"
            },
            {
              "kind": "Variable",
              "name": "audienceLanguages",
              "variableName": "languageFilter"
            }
          ],
          "kind": "ObjectValue",
          "name": "filters"
        }
      ],
      "concreteType": "GraphQLFeedPostConnection",
      "kind": "LinkedField",
      "name": "__FeedTabTable_feedPosts_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLFeedPostEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphQLFeedPost",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FeedTabTableRow_feedPost"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "f345af093bc3480e756de83130877d29";

export default node;
